/**
 * 主要用于报表的图表卡片右上角 展示 过滤条件的浮窗
 */
import React from "react";
import {useIntl} from "umi";
import { LANGUAGE_EN } from "@home/_config/config";
import BubbleListContent from "@/pages/datalab/components/BubbleListContent";
import { getLocalText } from "@/pages/datalab/utils/utils";

export const GeneralFilterList = (props: any) => {
  const { filters } = props;
  const { formatMessage, locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  return (
    <BubbleListContent
      title={formatMessage({id: 'dbl_filter_general_filter'})}
      list={filters?.map((filter: any) => (
        getLocalText(isEn, filter.scopeTextCn, filter.scopeTextEn)
      ))}
    />
  );
};

export const UserFilterControlList = (props: any) => {
  const { controls } = props;
  const { formatMessage, locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  if (controls?.length > 0) {
    return (
      <BubbleListContent
        title={formatMessage({id: 'dbl_filter_user_filter'})}
        list={controls?.map((control: any, index: number) => {
          const pre = formatMessage({id: 'dbl_filter_control_group_index'}, {index: index + 1});
          return (<>
            <span style={{color: '#fff'}}>{pre}</span>
            {getLocalText(isEn, control?.name_cn, control?.name_en)}
          </>);
        })}
      />
    );
  }
  return null;
};

export const ScopeChartList = (props: any) => {
  const { charts } = props;
  const { formatMessage, locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  if (charts?.length > 0) {
    return (
      <BubbleListContent
        title={formatMessage({id: 'dbl_create_dashboard_scope'})}
        list={charts?.map((chart: any) => getLocalText(isEn, chart.nameCn, chart.name))}
      />
    );
  }
  return null;
};

export const UserFilterControlFilterText = (props: any) => {
  const { title, text } = props;
  
  return (
    <BubbleListContent
      title={title}
      list={[text]}
    />
  );
};
